import React, { useState, useRef, useEffect } from "react";

interface HomeViewProps {
  onSearch: (query: string) => void;
  disabled?: boolean;
}

const EXAMPLE_QUERIES = [
  "Quel est le préavis de démission dans la métallurgie ?",
  "Quels sont les jours fériés dans la banque ?",
  "Comment calculer les congés payés dans la convention des télécoms ?",
  "Quelles sont les primes dans la convention SYNTEC ?",
];

export function HomeView({ onSearch, disabled }: HomeViewProps) {
  const [query, setQuery] = useState("");
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim() && !disabled) {
      onSearch(query.trim());
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // Auto-resize textarea
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = "auto";
      inputRef.current.style.height = `${Math.min(inputRef.current.scrollHeight, 150)}px`;
    }
  }, [query]);

  // Focus input on mount
  useEffect(() => {
    if (inputRef.current && !disabled) {
      inputRef.current.focus();
    }
  }, [disabled]);

  const handleExampleClick = (example: string) => {
    setQuery(example);
    inputRef.current?.focus();
  };

  return (
    <div className="home-view">
      <div className="home-content">
        <form className="home-search-form" onSubmit={handleSubmit}>
          <div className="search-container">
            <textarea
              ref={inputRef}
              className="search-input"
              value={query}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Posez votre question..."
              disabled={disabled}
              rows={1}
              aria-label="Question"
            />
            <button
              type="submit"
              className="search-button"
              disabled={disabled || !query.trim()}
              aria-label={disabled ? "Recherche en cours" : "Rechercher"}
            >
              {disabled ? (
                <span className="spinner" />
              ) : (
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                </svg>
              )}
            </button>
          </div>
        </form>

        <p className="search-hint">
          Astuce : mentionnez une convention, ex: métallurgie, IDCC 3248
        </p>

        <div className="example-queries">
          <span className="example-label">Exemples :</span>
          <div className="example-list">
            {EXAMPLE_QUERIES.map((example, i) => (
              <button
                key={i}
                className="example-query"
                onClick={() => handleExampleClick(example)}
                type="button"
              >
                {example}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
